import { privateApi, portalPrivateApi } from "../../http";
import { NotificationApiPath } from "../../../constants/api.paths";
const getApi = (isPortal = false) => {
    return isPortal ? portalPrivateApi() : privateApi();
};
export const getNotificationHistory = async (page = 0, size = 10, isPortal = false) => {
    const response = await getApi(isPortal).get(NotificationApiPath.HISTORY, {
        params: { page, size, sort: "tglCreate,desc" },
    });
    return response.data;
};
export const getUnreadNotificationCount = async (isPortal = false) => {
    const response = await getApi(isPortal).get(`${NotificationApiPath.HISTORY}/unread-count`);
    return response.data;
};
export const markNotificationAsRead = async (id, isPortal = false) => {
    await getApi(isPortal).put(`${NotificationApiPath.HISTORY}/${id}/read`);
};
export const markAllNotificationsAsRead = async (isPortal = false) => {
    await getApi(isPortal).put(`${NotificationApiPath.HISTORY}/read-all`);
};
